import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import styles from './AppLink.module.scss';

export interface AppLinkProps extends LinkProps {}

export const AppLink = ({
  to,
  children
}: AppLinkProps): React.ReactElement<AppLinkProps> => {
  return (
    <Link className={styles.appLink} to={to}>
      {children}
    </Link>
  );
};
